<template>
  <ut-list divided border style="margin:10px">
    <ut-list-item v-for="item in values" :key="item.host">
      <div slot="avatar" width="35">
        <ut-button :type="formatStatus(item.status)">{{formatStr(item.status)}}</ut-button>
      </div>
      <div slot="description">{{item.host}}</div>
    </ut-list-item>
  </ut-list>
</template>
<script>
export default {
  data () {
    return {
      values: []
    }
  },
  methods: {
    formatStatus (status) {
      switch (status) {
        case '0': {
          return 'danger'
        }
        case '1': {
          return 'success'
        }
      }
    },
    formatStr (status) {
      switch (status) {
        case '0': {
          return '不存活'
        }
        case '1': {
          return '存活'
        }
      }
    }
  },
  created () {
    var name = 'apusLoginInfo'
    var arr; var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    arr = document.cookie.match(reg)
    // console.log("arr cookie : " + arr);
    if (arr == undefined || arr == null || arr.length < 1) {
      console.log('跳转login')
      // location.href = '#/login'
      return
    }

    this.$http({
      method: 'post',
      url: 'getOnlineServer.htm?q=' + new Date().getTime(),
      data: '{}'
    })
      .then(response => {
        if (response.data.result != 0) {
          this.$message.info(`系统异常跳回登录`)
          // this.$router.push({ path: '/login' })
        }
        if (response === undefined) {
          // console.log("没有返回数据");
          this.$message.info(`系统异常跳回登录`)
          // this.$router.push({ path: '/login' })
        }
        if (response !== undefined) {
          console.log('response message: ' + response.data.message) // 请求成功返回的数据
          var json = JSON.parse(response.data.message)
          this.values = json
        }
      })
      .catch(error => {
        console.log(error) // 请求失败返回的数据
      })
  }
}
</script>
